// extracted by mini-css-extract-plugin
module.exports = {"container":"_ae9aad6","details":"_6a15d4c","inPlay":"_c604e1d"};